import React from "react"

import BasePermissionGate, { BasePermissionGateProps } from "@/components/PermissionGate/BasePermissionGate"

const QuickReplyGroupPermissionGate = (props: Omit<BasePermissionGateProps<"quick-reply">, "feature">) => {
	return (
		<BasePermissionGate
			{...props}
			feature="quick-reply"
		/>
	)
}

export default QuickReplyGroupPermissionGate
